import PropTypes from 'prop-types'
import { Component } from 'react'
import ImmutableTypes from 'react-immutable-proptypes'
import SimpleSelect from 'components/shared/SimpleSelect'

class OnlineInputs extends Component {
  static propTypes = {
    conditionUpdater: PropTypes.func,
    conditionValue: ImmutableTypes.map,
  }

  onSelect = (value) => {
    this.props.conditionUpdater('value', value)
  }

  render() {
    const { conditionValue } = this.props
    return (
      <SimpleSelect
        className="AriaMenuButton--small"
        onSelection={this.onSelect}
        options={[
          { value: true, text: 'is Online' },
          { value: false, text: 'is Offline' },
        ]}
        selectedValue={conditionValue.get('value') ? 'is Online' : 'is Offline'}
      />
    )
  }
}

export default OnlineInputs



// WEBPACK FOOTER //
// ./src/scripts/components/CampaignWizards/TargetingInputArea/TargetConditionInput/TargetConditionEditModal/OnlineInputs.js